import { Tooltip, IconButton } from '@mui/material';
import { FilterListOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { V4_ICON_BUTTON } from '../theme/v4Compat';

interface ClearFiltersProps {
  onClick: () => void;
}

const ClearFilters = ({ onClick }: ClearFiltersProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t('f-com-filter-clear')}>
      {/* Most toolbars this sits in are still v4, where it would otherwise be the one small button. */}
      <IconButton onClick={onClick} sx={V4_ICON_BUTTON}>
        <FilterListOff color="action" id="clearFiltersBtn" />
      </IconButton>
    </Tooltip>
  );
};

export default ClearFilters;
